import React from 'react';
import { useSiteFeatureFlags } from '../../hooks/useSiteFeatureFlags';
import TransferLanding from '../../pages/TransferLanding';

/**
 * The "/" route. With "File Transfer as Home Page" on (the backend only reports
 * it on while File Transfer itself is on) the home page is the transfer landing;
 * otherwise it is the normal home page passed in as `fallback`.
 */
const HomeSwitch = ({ fallback }) => {
  const { _loaded, transfer_home_enabled } = useSiteFeatureFlags();
  if (!_loaded) return null;
  return transfer_home_enabled ? <TransferLanding /> : fallback;
};

export default HomeSwitch;
